import React from "react";

// ============ Auth ============
export const ResetPassword = React.lazy(() => import("pages/ResetPassword"));
export const PasswordEditForm = React.lazy(() =>
  import("pages/PasswordEditForm")
);
export const VerificationCodeForm = React.lazy(() =>
  import("pages/VerificationCodeForm")
);
// ============ Auth ============

// ============ DashboardRouting ============
export const DashboardRouting = React.lazy(() =>
  import("../modules/dashboard/DashboardRouting")
);
export const SliderRouting = React.lazy(() =>
  import("../modules/slider/SliderRouting")
);
export const TestimonialRouting = React.lazy(() =>
  import("../modules/testimonial/TestimonialRouting")
);
export const FeatureRouting = React.lazy(() =>
  import("../modules/feature/FeatureRouting")
);
export const CategoryRouting = React.lazy(() =>
  import("../modules/category/CategoryRouting")
);
export const SettingRouting = React.lazy(() =>
  import("../modules/setting/SettingRouting")
);

// ============ DashboardRouting ============
